/* Autocompletado del buscador (combobox ARIA) sobre /search/suggest.json.
   ↑/↓ mueven la opción activa, Enter la abre (o envía el form si no hay ninguna), Esc cierra. */
(() => {
  const root = window.Shopify?.routes?.root ?? '/';
  document.querySelectorAll('[data-predictive-search]').forEach((wrap) => {
    const input = wrap.querySelector('input[role="combobox"]');
    const box = wrap.querySelector('[role="listbox"]');
    const L = wrap.dataset;
    let timer = null;
    let ctrl = null;
    let active = -1;

    const moneyFormat = L.moneyFormat || '${{amount}}';
    const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const money = (amount) => {
      const [int, dec] = Number(amount).toFixed(2).split('.');
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
        amount: `${group(int, ',')}.${dec}`, amount_no_decimals: group(int, ','),
        amount_with_comma_separator: `${group(int, '.')},${dec}`, amount_no_decimals_with_comma_separator: group(int, '.'),
      }[k] ?? amount));
    };
    const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
    const options = () => [...box.querySelectorAll('[role="option"]')];

    function close() {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }
    function setActive(i) {
      const opts = options();
      opts.forEach((o, j) => o.classList.toggle('bg-lacre-500/10', j === i));
      active = i;
      if (i >= 0 && opts[i]) { input.setAttribute('aria-activedescendant', opts[i].id); opts[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }

    function render(q, results) {
      box.replaceChildren();
      let n = 0;
      const option = (href, label, sub, img, extra) => {
        const a = el('a', 'flex items-center gap-3 px-4 py-2.5 mx-1 rounded-lg transition-colors hover:bg-lacre-500/5');
        a.href = href; a.id = `${input.id}-opt-${n++}`; a.setAttribute('role', 'option');
        if (img !== undefined) {
          if (img) { const i = el('img', 'w-12 h-12 rounded-lg object-cover flex-shrink-0'); i.src = img; i.alt = ''; i.width = 48; i.height = 48; i.loading = 'lazy'; a.append(i); }
          else a.append(el('span', 'w-12 h-12 rounded-lg bg-muted flex-shrink-0'));
        }
        const t = el('span', 'flex-grow min-w-0');
        t.append(el('span', 'block text-sm font-sans text-foreground truncate', label));
        if (sub) t.append(el('span', 'block text-xs font-sans text-muted-foreground truncate', sub));
        a.append(t);
        if (extra) a.append(el('span', 'text-xs font-sans text-foreground font-semibold flex-shrink-0', extra));
        return a;
      };
      const section = (title, items, map) => {
        if (!items?.length) return;
        box.append(el('p', 'px-4 pt-3 pb-1 font-sans text-xs font-semibold text-muted-foreground', `${title}${title === L.lProducts ? ` (${items.length})` : ''}`));
        items.forEach((it) => box.append(map(it)));
      };
      section(L.lProducts, results.products, (p) => option(p.url, p.title, null, p.image || p.featured_image?.url || '', Number(p.price) > 0 ? money(p.price) : L.lOnRequest));
      section(L.lCollections, results.collections, (c) => option(c.url, c.title));
      section(L.lPages, results.pages, (p) => option(p.url, p.title));
      section(L.lArticles, results.articles, (a) => option(a.url, a.title));
      if (n === 0) {
        const none = el('p', 'px-4 py-6 text-center text-muted-foreground font-sans text-sm', `${L.lNone} `);
        none.append(el('span', 'text-lacre-300', `"${q}"`));
        box.append(none);
      }
      const all = el('a', 'block w-full text-center py-3 text-xs font-sans font-semibold text-lacre-300 transition-colors border-t border-line-hair hover:bg-lacre-500/5', L.lViewAll.replace('__Q__', q));
      all.href = `${root}search?q=${encodeURIComponent(q)}&type=product,article,page`;
      all.id = `${input.id}-opt-${n++}`; all.setAttribute('role', 'option');
      box.append(all);
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      setActive(-1);
    }

    async function search(q) {
      ctrl?.abort();
      ctrl = new AbortController();
      const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last`;
      try {
        const data = await (await fetch(url, { signal: ctrl.signal })).json();
        if (input.value.trim() === q) render(q, data.resources?.results ?? {});
      } catch (e) { if (e.name !== 'AbortError') close(); }
    }

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => search(q), 150);
    });
    input.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      const opts = options();
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(active + 1, opts.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, -1)); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); location.href = opts[active].href; }
    });
    document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) close(); });
  });
})();
